/* ACTIVITY PAGE */
Vue.component('activitypage',{
    template:'#activitypage-template',
    data:function(){
        return{
            moment:moment,
            Autolinker: Autolinker,
            user_activities:[],
            feed:[],
            filtered:[],
            time_order:"desc",
            current_interval_string:'lastMonth',
        };
    },
    created:function(){
        activeInstance = this;
        setTimeout(function(){
            activeInstance.getActivityList();
            
            document.title = 'Tevékenység - ODIN Enterprise Manager';
            $("#page_title").text('TEVÉKENYSÉG');
        },100);
    },
    methods:{
        humanDate:function($date){
            return moment($date).fromNow();
        },
        getActivityList:function(){
            showLoadingOverlay();

            Vue.http.get(baseURL+'/ajax/activity/list').then(function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.feed = response.data;
                activeInstance.timeFilter('lastMonth');
            }).bind(this);
        },
        timeFilter:function(intervalString){

            activeInstance.current_interval_string = intervalString;

            switch(intervalString){
                case 'lastMonth':
                    var filtered = [];
                    $.each(activeInstance.feed,function(index,feed_record){
                        if( moment(feed_record.created_at) > moment().subtract(1,'month') ){
                            filtered.push(feed_record);
                        }
                    });
                    console.log(filtered);

                    if(activeInstance.time_order == 'asc') {
                        filtered.sort(function(a,b){
                            return new Date(a.created_at) - new Date(b.created_at);
                        });
                    }
                    else{
                        filtered.sort(function(a,b){
                            return new Date(b.created_at) - new Date(a.created_at);
                        });
                    }


                    activeInstance.filtered = filtered;
                    break;
                case 'lastWeek':
                    var filtered = [];
                    $.each(activeInstance.feed,function(index,feed_record){
                        if( moment(feed_record.created_at) > moment().subtract(1,'week') ){
                            filtered.push(feed_record);
                        }
                    });
                    if(activeInstance.time_order == 'asc') {
                        filtered.sort(function(a,b){
                            return new Date(a.created_at) - new Date(b.created_at);
                        });
                    }
                    else{
                        filtered.sort(function(a,b){
                            return new Date(b.created_at) - new Date(a.created_at);
                        });
                    }
                    activeInstance.filtered = filtered;
                    console.log(filtered);
                    break;
                case 'lastDay':
                    var filtered = [];
                    $.each(activeInstance.feed,function(index,feed_record){
                        if( moment(feed_record.created_at) > moment().subtract(1,'day') ){
                            filtered.push(feed_record);
                        }
                    });
                    if(activeInstance.time_order == 'asc') {
                        filtered.sort(function(a,b){
                            return new Date(a.created_at) - new Date(b.created_at);
                        });
                    }
                    else{
                        filtered.sort(function(a,b){
                            return new Date(b.created_at) - new Date(a.created_at);
                        });
                    }
                    activeInstance.filtered = filtered;
                    console.log(filtered);
                    break;
            }
        }
    }
}); 